import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Card, CardContent, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Theme from '../ui/Theme';
import ImageAvatar from '../common/Avatar';
import { searchEmployees } from '../utils/Utils';

const useStyles = makeStyles(() => ({
  popupHeading: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
    paddingLeft: '18px',
  },
  avatarStyle: {
    height: '48px',
    width: '48px',
  },
  cardContent: {
    marginRight: '10px',
    borderRadius: '8px',
    marginTop: '10px',
    marginBottom: '5px',
    height: '48px',
    border: ' 1px solid #E4E7EC',
  },
  scrollContent: {
    marginTop: '10px',
    width: '100%',
    maxHeight: '300px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  employeeName: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '170px',
    whiteSpace: 'nowrap',
    display: 'block',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontStyle: 'normal',
    color: '#10182B',
  },
  searchText: {
    width: '511px',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
  },
  statusText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontStyle: 'normal',
    color: '#10182B',
    textTransform: 'capitalize',
    fontSize: '12px',
  },
}));

const EmployeeItem = ({ emp }) => {
  const classes = useStyles();

  return (
    <Card className={classes.cardContent}>
      <CardContent>
        <Grid
          container
          justifyContent="space-evenly"
          alignItems="center"
          className={classes.gridContainer}
          id={emp.hash}
        >
          <Grid item xs={2}>
            <ImageAvatar
              alt={emp.name}
              src={emp.profilePic || '/static/images/avatar/1.jpg'}
              className={classes.avatarStyle}
            />
          </Grid>
          <Grid item xs={10}>
            <Typography className={classes.employeeName}>
              {emp.firstName} {emp.lastName}
            </Typography>
            <Typography className={classes.statusText}>
              {emp.enabled ? (
                <span style={{ color: '#039855' }}>Enabled</span>
              ) : (
                <span style={{ color: '#D92D20' }}>Disabled</span>
              )}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const EmployeeList = ({ employeesList, close }) => {
  const classes = useStyles();
  const [searchEmpVal, setSearchEmpVal] = useState('');
  const [filterEmpArray, setFilterEmpArray] = React.useState([]);

  useEffect(() => {
    setFilterEmpArray(employeesList);
  }, [employeesList]);

  const handleSearchEmployee = (e) => {
    const input = e.target.value;
    setSearchEmpVal(input);

    const filteredIArray = searchEmployees(employeesList, input);
    setFilterEmpArray(filteredIArray);
  };

  return (
    <Modal
      isOpen
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: employeesList?.length ? '424px' : '100px',
          width: '511px',
          overflow: 'auto',
          borderRadius: '8px',
        },
        popupCloseBtn: {
          borderRadius: '50%',
          backgroundColor: Theme.palette.secondary.main,
          padding: '8px',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          },
          cursor: 'pointer',
        },
      }}
    >
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={11}>
          <p className={classes.popupHeading}>Employees</p>
        </Grid>
        <Grid item xs={1} style={{ cursor: 'pointer' }}>
          <CloseIcon className={classes.popupCloseBtn} onClick={close} />
        </Grid>
      </Grid>
      <div>
        {employeesList?.length ? (
          <div>
            <Grid item style={{ margin: '10px 0' }}>
              <Grid container direction="row">
                <Grid item>
                  <TextField
                    id="searchId"
                    name="search"
                    required
                    autoComplete="off"
                    autoSave="off"
                    onChange={handleSearchEmployee}
                    placeholder="Search Employees"
                    value={searchEmpVal}
                    InputProps={{
                      disableUnderline: true,
                      className: classes.searchText,
                    }}
                    rows={1}
                  />
                </Grid>
              </Grid>
            </Grid>
            <div className={classes.scrollContent}>
              <Grid container style={{ marginLeft: '5px', marginTop: '5px' }}>
                {filterEmpArray.length ? (
                  filterEmpArray.map((emp) => (
                    <Grid item md={6} key={emp.id}>
                      <EmployeeItem emp={emp} />
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12} style={{ textAlign: 'center', marginTop: '10px' }}>
                    No Employees Found
                  </Grid>
                )}
              </Grid>
            </div>
          </div>
        ) : (
          <Grid item xs={12} style={{ textAlign: 'center', marginTop: '10px' }}>
            No Employees
          </Grid>
        )}
      </div>
    </Modal>
  );
};

export default EmployeeList;
